export default __webpack_public_path__ + "static/media/score-target.886455ee.png";